/**
 * Site header
 */

let openMenuButton = $('.js-site-header-menu-button');
let closeMenuButton = $('.js-site-header-close-menu-button');
let overlayMenu = $('.js-overlay-menu');
let navWrapper = $('.js-site-header-nav-wrapper');
let linkDropdown = $('.js-menu-link-dropdown');

function openMenu() {
    openMenuButton.attr('aria-expanded', 'true')
    closeMenuButton.attr('aria-expanded', 'true')
    navWrapper.addClass('is-active');
    overlayMenu.addClass('is-active');
    trapFocus(navWrapper);
}

function closeMenu() {
    openMenuButton.attr('aria-expanded', 'false')
    closeMenuButton.attr('aria-expanded', 'false')
    navWrapper.removeClass('is-active');
    overlayMenu.removeClass('is-active');
    unTrapFocus(openMenuButton);
}
function toggleSublist(e) {
    e.preventDefault();
    if (!$(this).hasClass('is-active')) {
        linkDropdown.removeClass('is-active');
        linkDropdown.attr('aria-expanded', 'true')
        $('.js-site-header-nav-sublist').slideUp();
        $(this).addClass('is-active').next('.js-site-header-nav-sublist').stop(true, true).slideDown();
        trapFocus($(this).next('.js-site-header-nav-sublist'));
    } else {
        $(this).attr('aria-expanded', 'false')
        $(this).removeClass('is-active').next('.js-site-header-nav-sublist').stop(true, true).slideUp();
        unTrapFocus($(this).prev('.js-menu-link-dropdown'));
    }
}

function closeAllSublits() {
    linkDropdown.removeClass('is-active');
    linkDropdown.removeClass('is-active');
    $('.js-site-header-nav-sublist').filter(':visible').stop(true, true).slideUp().prev('.js-menu-link-dropdown').focus();
}

openMenuButton.on('click', openMenu);

closeMenuButton.on('click', closeMenu);

linkDropdown.on('click', toggleSublist);

$(document).on('keydown', function (e) {
    if (e.key == 'Escape') { 
        if (linkDropdown.hasClass('is-active')) {
            closeAllSublits();
        } else if (navWrapper.hasClass('is-active')) {
            closeMenu();
        }
    }
});

$(document).on('click', function (e) {
    let $target = $(e.target);
    if (!$target.closest('.c-site-header').length && navWrapper.hasClass('is-active') || $target.is(overlayMenu)) {
        closeMenu();
    } else if (!$target.closest('.c-site-header-nav__list').length && linkDropdown.hasClass('is-active')) {
        closeAllSublits();
    }
});